import { Navigate } from 'react-router-dom';
import { AppNavMenu, AppRoute } from 'src/pages';
import { CallList, CallDetailsRoute } from './calls';
import { PhoneOutlined } from '@ant-design/icons';

export const phoneTriageRoutes: AppRoute[] = [
  {
    path: '/phone-triage',
    element: <Navigate to="/phone-triage/calls" />,
  },
  {
    path: '/phone-triage/calls',
    element: <CallList />,
  },
  {
    path: '/phone-triage/calls/:callId',
    element: <CallDetailsRoute />,
  },
];

export const phoneTriageNavMenus: AppNavMenu[] = [
  {
    path: '/phone-triage/calls',
    title: 'Phone',
    icon: <PhoneOutlined />,
  },
];
